import ICON_SIZE, { ICON_COLOR } from '@/constant/icon-size-color';

export default function IoIosCodeWorking({
  color = ICON_COLOR.gray,
  size = ICON_SIZE.lg,
}: {
  color?: string;
  size?: number;
}) {
  return (
    <svg
      stroke={color}
      fill={color}
      strokeWidth='0'
      viewBox='0 0 512 512'
      height={size}
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M446.1 251.6L332 142.7c-1.2-1.1-2.7-1.7-4.1-1.7s-3 .6-4.1 1.7L310 155.9c-1.2 1.1-1.9 2.7-1.9 4.3 0 1.6.7 3.2 1.9 4.3l95.8 91.5-95.8 91.5c-1.2 1.1-1.9 2.7-1.9 4.3 0 1.6.7 3.2 1.9 4.3l13.8 13.2c1.2 1.1 2.6 1.7 4.1 1.7 1.5 0 3-.6 4.1-1.7l114.2-109c1.2-1.1 1.9-2.7 1.9-4.3-.1-1.7-.8-3.2-2-4.4zM106.3 256l95.8-91.5c1.2-1.1 1.9-2.7 1.9-4.3 0-1.6-.7-3.2-1.9-4.3l-13.8-13.2c-1.2-1.1-2.7-1.7-4.1-1.7s-3 .6-4.1 1.7l-114.2 109c-1.2 1.1-1.9 2.7-1.9 4.3 0 1.6.7 3.2 1.9 4.3l114.2 109c1.2 1.1 2.7 1.7 4.1 1.7 1.5 0 3-.6 4.1-1.7l13.8-13.2c1.2-1.1 1.9-2.7 1.9-4.3 0-1.6-.7-3.2-1.9-4.3L106.3 256z'></path>
      <circle cx='256' cy='256' r='22'></circle>
      <circle cx='192' cy='256' r='22'></circle>
      <circle cx='320' cy='256' r='22'></circle>
    </svg>
  );
}
